import { useEffect, useRef } from "react";
import { api } from "../../api/client.js";
import type { Message } from "../../api/types.js";

type UseVerificationPollingInput = {
  currentAssistant: Message | null;
  onJobUpdate: (messageId: string, items: any[], status: string) => void;
};

export function useVerificationPolling({ currentAssistant, onJobUpdate }: UseVerificationPollingInput) {
  const terminalVerificationJobs = useRef(new Set<string>());
  const onJobUpdateRef = useRef(onJobUpdate);
  onJobUpdateRef.current = onJobUpdate;

  useEffect(() => {
    const timer = setInterval(() => {
      const jobId = currentAssistant?.meta?.verificationJobId;
      if (!jobId || !currentAssistant || terminalVerificationJobs.current.has(jobId)) return;
      api<{ job: any }>(`/api/citation-verification/jobs/${jobId}`).then((data: { job: any }) => {
        onJobUpdateRef.current(currentAssistant.id, data.job.items || [], data.job.status);
        if (["completed", "failed"].includes(data.job.status)) {
          terminalVerificationJobs.current.add(jobId);
        }
      }).catch(() => undefined);
    }, 3500);
    return () => clearInterval(timer);
  }, [currentAssistant?.id, currentAssistant?.meta?.verificationJobId]);
}
